import { NavLink, Outlet } from '@remix-run/react'

const tabs = [
	{ name: 'Wee Dance', href: 'wee-dance' },
	{ name: 'Twinkling Stars', href: 'twinkling-stars' },
	{ name: 'Mini Movers', href: 'mini-movers' },
	{ name: 'Dance Explosion', href: 'dance-explosion' },
	{ name: 'Dance Out Loud', href: 'dance-out-loud' },
]

export default function SummerClasses() {
	return (
		<div className="relative isolate min-h-screen overflow-hidden bg-stone-900 pb-24">
			<div className="mx-auto mt-24 max-w-5xl px-4 py-10 sm:px-6 sm:py-16 lg:px-8">
				<div className="absolute inset-x-0 top-1/2 -z-10 -translate-y-1/2 transform-gpu overflow-hidden opacity-30 blur-3xl">
					<svg
						viewBox="0 0 1313 771"
						aria-hidden="true"
						className="ml-[max(50%,38rem)] w-[82.0625rem]"
					>
						<path
							id="bc169a03-3518-42d4-ab1e-d3eadac65edc"
							fill="url(#85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3)"
							d="M360.508 589.796 231.671 770.522 0 498.159l360.508 91.637 232.034-325.485c1.485 150.396 51.235 393.965 238.354 165.069C1064.79 143.261 1002.42-107.094 1171.72 46.97c135.44 123.252 148.51 335.641 138.11 426.428L971.677 339.803l24.062 411.461-635.231-161.468Z"
						/>
						<defs>
							<linearGradient
								id="85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3"
								x1="1313.17"
								x2="-88.881"
								y1=".201"
								y2="539.417"
								gradientUnits="userSpaceOnUse"
							>
								<stop stopColor="#9089FC" />
								<stop offset={1} stopColor="#FF80B5" />
							</linearGradient>
						</defs>
					</svg>
				</div>
				<div className="absolute inset-x-0 top-0 -z-10 flex transform-gpu overflow-hidden pt-32 opacity-25 blur-3xl sm:pt-40 xl:justify-end">
					<svg
						viewBox="0 0 1313 771"
						aria-hidden="true"
						className="ml-[-22rem] w-[82.0625rem] flex-none origin-top-right rotate-[30deg] xl:ml-0 xl:mr-[calc(50%-12rem)]"
					>
						<use href="#bc169a03-3518-42d4-ab1e-d3eadac65edc" />
					</svg>
				</div>
				<div className="flex items-center">
					<div className="flex-auto">
						<h2 className="text-base font-semibold uppercase tracking-wide text-stone-200">
							2026
						</h2>
						<h3 className="mt-2 text-3xl font-extrabold leading-8 text-stone-50 sm:text-4xl">
							Summer Class Schedule
						</h3>
						{/* <p className="mt-2 text-sm text-stone-300">
							Classes run from June 17, 2025 to August 15, 2025.
						</p> */}
					</div>
				</div>
				<div className="mt-4 overflow-x-auto py-4 sm:mt-8">
					<nav
						className="inline-flex h-auto w-full min-w-max justify-start gap-1 overflow-x-auto bg-inherit p-0 sm:justify-center"
						aria-label="Tabs"
					>
						{tabs.map((tab) => (
							<NavLink
								preventScrollReset={true}
								key={tab.name}
								to={tab.href}
								className={({ isActive }) =>
									isActive
										? 'rounded-md bg-stone-100 px-3 py-2 text-xs font-medium text-stone-700 sm:text-sm'
										: 'rounded-md px-3 py-2 text-xs font-bold text-[#f9c04d] hover:text-stone-50 sm:text-sm'
								}
							>
								{tab.name}
							</NavLink>
						))}
					</nav>
				</div>
				<Outlet />
				{/* <div className="mt-16 sm:mt-20 lg:mt-24">
					<p className="text-sm leading-5 text-stone-200">
						* Means accelerated level. Entry into class by teacher approval
						only.
					</p>
				</div> */}
			</div>
		</div>
	)
}
